// import React from 'react';
// import TopBar from '../components/TopBar';
// import Header from '../components/Header';
// import Navbar from '../components/Navbar';

const Consulting = () => (
  <>


    <div className="divTitle">
      <h1 className="title">Consultancy</h1>
    </div>

    <img src={`${process.env.PUBLIC_URL}/images/consult.webp`} alt="Consulting" className="consultingImg" />


    <hr />

    <p className="desc">
      Our consulting services are designed to help businesses navigate complex financial, regulatory, and strategic challenges with clarity and confidence. We offer expert advisory across a wide spectrum, including business setup and structuring, financial planning, risk management, cost optimization, regulatory compliance, and performance improvement. Our consultants work closely with clients to understand their unique business models, goals, and pain points, and deliver tailored solutions that drive efficiency and sustainable growth. Whether you’re looking to expand operations, improve internal controls, streamline tax structures, or prepare for fundraising, we bring a strategic perspective backed by deep financial expertise. We also assist in preparing detailed project reports, feasibility studies, management information systems (MIS), and strategic turnaround plans for businesses in distress. With a client-centric approach and a commitment to excellence, we serve as trusted advisors to startups, SMEs, and large enterprises across diverse industries—enabling informed decision-making and long-term success.
    </p>

    

  </>
);

export default Consulting;